import { FormContainer as Container, InputField as Input } from "../../components";
import { useInjectFormProps } from "../../hooks/useInjectInputs.js";
import { useNavigate } from "react-router-dom";
import { validateStep } from "../../utils/pageValidator.js";
import FormContext from "../../context/FormContext.js";
import { useContext } from "react";
import { FORM_FIELDS } from "../../utils/constants.js";

function InitialForm() {
    const { formData } = useContext(FormContext);

    const { injectFormProps } = useInjectFormProps();
    const navigate = useNavigate();

    const beforeSubmit = () => {
        if (!validateStep()) {
            return;
        }
        if (formData["isCanCit"] === "1") {
            navigate("/main-form");
            return;
        } else {
            navigate("/swis-agreement");
            return;
        }
    }
    return (
        <Container>
            {injectFormProps(
                <>
                    <p style={{ fontSize: "1.8rem", fontWeight: "500" }}>Before you start:</p>
                    <hr />
                    <div style={{ backgroundColor: "var(--form-section-color)", border: "4px double black", padding: "10px", textAlign: "center", lineHeight: "25px", }}>
                        <b>LOCAL AUTHORITY FREEDOM OF INFORMATION & PROTECTION OF PRIVACY
                        </b>
                        <p style={{ color: "black" }}>The personal information requested on this form as part of the
                            school registration process is collected under the authority of Saskatchewan’s
                            Local Authority Freedom of Information and Protection of Privacy Act (LAFOIP)
                            for the establishment of a student record, determination of residency,
                            to provide students with an education program that meets their needs, to provide a safe and secure school environment,
                            for program placement, determination of eligibility and/or suitability for provincial or federal funding,
                            to manage problems or emergencies, for reporting and providing statistics to the Minister of Education,
                            and for other purposes that relate directly to and are necessary for the school's operating programs and activities.
                            This information will be managed in accordance with the privacy protection provisions of the LAFOIP Act.</p>
                    </div>
                    <hr />
                    <Input type="radiooptions" inputLabel={"Who is filling out this registration form?"} identifier={FORM_FIELDS.REGISTRANT_TYPE}
                        options={[{ label: "Parent or Guardian of the Student", value: "PG" },
                        { label: "Student (16 years or older, completing on their own behalf)", value: "STUD" }]} />
                    <Input type="text" inputLabel={"Enter your full name"} identifier={FORM_FIELDS.REGISTRANT_NAME}></Input>
                    <Input type="email" inputLabel={"Please provide the email address that this registration confirmation will be sent to"} identifier={FORM_FIELDS.LAFOIP_SIGNATURE_EMAIL}></Input>
                    <hr />
                    <h2>Consent to use electronic signatures</h2>
                    <i>
                        By clicking "Accept," you agree to use an electronic signature and acknowledge that the name entered above will serve as your legally binding signature, equivalent to a handwritten signature on a physical document.
                    </i>
                    <br /><br />
                    <button type="button" onClick={beforeSubmit} className={"default-btn justify-center"}>Accept</button>
                </>
            )}
        </Container>
    );
}

export default InitialForm;